export const getPermission = (string) => {
    const data = JSON.parse(localStorage.getItem('bor-admin-login-data'));
    console.log(data?.assignedSections)
  
    if (!data) {
      console.log('No data found in local storage');
      return false;
    }
  
    for (const obj of data?.assignedSections) {
      if (string === obj?.section_name) {
        return true;
      }
    }
  
    return false;
  };